import { assetsURLs, Loadable, TheatreCoreResources } from "@kosmod/theatre";
import { Component, h, useEffect, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './index.module.css';
import { createListAnimationHook, easeOutQuad } from "@kosmod/kit/list";
import { Animation, bezier4, lerp, useAnimation } from "@kosmod/kit";

export type LoadingProps = {
  visible?: boolean,
  roomName?: string,

  ready?: boolean,

  connection: {
    target: string,
    connected: 'not-started' | 'initiated' | 'connected'
  },
  sections: {
    name: string,
    loadables: Loadable[]
  }[],

  otherPlayers?: number,

  onAcceptJoinClick?(): void,
  autoAccept?: boolean
}

const useListAnim = createListAnimationHook(
  () => 'CONST',
  800,
  () => Animation(performance.now(), 800, [0, 1, 1, 1], ([a, b, c, d], t) => bezier4(a, b, c, d, easeOutQuad(t)))
);
const PopupAnimation: Component<{ state: ReturnType<typeof useListAnim>[number] }> = ({ children, state }) => {
  const ref = useRef<HTMLElement | null>(null);

  useAnimation(state.anim, (point) => {
    const el = ref.get()!;

    el.style.transform = `translateY(${Math.abs((1 - point)) * 256}px)`
    el.style.opacity = (1 - Math.abs(point - 1)).toString();
  })

  useEffect(() => {
    console.log('test: mounted');
    
    return () => {
      console.log('test: unmounted');
    }
  }, [])

  return h(html.div, { ref, style: { position: 'absolute', width: '100%', height: '100%', zIndex: '1' } }, children)
}

export const Loading: Component<LoadingProps> = ({
  sections, visible = true,
  connection, onAcceptJoinClick, roomName,
  ready: externalReady = true,
  otherPlayers = 0
}) => {
  const popups = useListAnim(visible ? [true] : [])

  const ready = !sections.some(s => s.loadables.some(l => !l[1])) && externalReady;

  return popups.map((state) => {
    return h(PopupAnimation, { state, key: state.key }, [
      h(html.div, { className: classes.popupContainer }, [
        h(html.h2, {}, !ready ? 'Loading' : `Ready to join "${roomName}"`),
        h(html.div, { className: classes.connectionRow }, [
          connection.target,
          connection.connected === 'connected' && h(html.img, { src: assetsURLs.icons.tickBlackCircle, className: classes.connectedIcon })
        ]),
        sections.map(section => {
          return h(html.section, { className: classes.loadingSection }, [
            h(html.h4, {}, [section.name, ` [${section.loadables.filter(l => l[1]).length}]`]),
            h(html.ol, { className: classes.loadingList }, [
              section.loadables.map(([name, loaded]) => {
                return h(html.li, { classList: [classes.loadingListItem, loaded && classes.loaded] }, [
                  name, h(html.img, { src: assetsURLs.icons.tickBlackCircle })
                ])
              })
            ])
          ])
        }),
        otherPlayers > 0 && h(html.section, { className: classes.loadingSection }, [
          h(html.p, {}, `${otherPlayers} other players connected.`)
        ]),
        h(html.button, {
          className: classes.enterRoomButton,
          onClick: onAcceptJoinClick,
          disabled: !ready,
        }, 'Enter Room')
      ])
    ])
  });
};